import * as PostActions from 'mattermost-redux/actions/posts';

import {getLogErrorAction} from 'mattermost-redux/actions/errors';

import {ActionTypes, AnnouncementBarTypes} from 'utils/constants';
import {getPost} from 'mattermost-redux/selectors/entities/posts';
import {getCurrentTeamId} from 'mattermost-redux/selectors/entities/teams';

export function editPost(post) {
    return async (dispatch, getState) => {
        const state = getState();
        const currentPost = getPost(state, post.id);

        if (post.message?.includes('~')) {
            post.props = {
                ...currentPost.props,
                ...post.props,
                team_id: getCurrentTeamId(state),
            };
        }

        const result = await PostActions.editPost(post, currentPost)(dispatch, getState);

        // Send to error bar if it's an edit post error about time limit.
        if (result.error && result.error.server_error_id === 'api.post.update_post.permissions_time_limit.app_error') {
            dispatch(getLogErrorAction({type: AnnouncementBarTypes.ANNOUNCEMENT, message: result.error.message}, true));
        }

        return result;
    };
}

export function selectAttachmentMenuAction(postId, actionId, cookie, dataSource, text, value) {
    return async (dispatch) => {
        dispatch({
            type: ActionTypes.SELECT_ATTACHMENT_MENU_ACTION,
            data: {
                postId,
                actions: {
                    [actionId]: {
                        text,
                        value,
                    },
                },
            },
        });

        dispatch(PostActions.doPostActionWithCookie(postId, actionId, cookie, value));

        return {data: true};
    };
}
